import { Button, Col, Form, Input, message } from 'antd';
import { useCreatePassword } from 'features/auth/use-cases/set-password';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

import { StyledBackground, StyledCard, StyledRow } from './login.styles';

export const ChangePassword = () => {
  const [form] = Form.useForm(); // Ant Design form instance for field access
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, mutate } = useCreatePassword();
  const onFinish = (formValue: any) => {
    const payload: any = {
      UniqueId: id,
      Password: formValue.password,
    };
    mutate(payload, {
      onSuccess: (data: any) => {
        // console.log('data_response'+JSON.stringify(data));
        if (data?.rs == 1) {
          localStorage.clear();
          navigate(ROUTES.LOGIN);
          message.success('Password Change Successfully');
        } else {
          message.error(data?.rm);
        }
      },
      onError: (error: any) => {
        message.error(error);
      },
    });
  };

  return (
    <StyledBackground>
      <Col
        xs={24}
        sm={18}
        md={12}
        lg={12}
        xl={10}
        xxl={6}
        className='flex flex-col justify-center'
      >
        <Col xs={24} className='flex justify-center mb-10'>
          <img src='/partnerplus_logo.png' alt='login background' />
        </Col>

        <StyledCard>
          <StyledRow justify='center'>
            <Col className='w-full'>
              <div className='text-center mb-5'>
                <label className='mt-0 mb-5 text-center text-2xl font-bold text-blue-950'>
                  Set Password?
                </label>
              </div>
              <Form form={form} layout='vertical' onFinish={onFinish}>
                {/* New Password */}
                <Form.Item
                  label='New Password'
                  name='password' // Changed to lowercase to match confirmPassword validator
                  rules={[
                    {
                      required: true,
                      message: 'Please enter a new password',
                    },
                    {
                      pattern:
                        /^(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
                      message:
                        'Password must be at least 8 characters long and include one uppercase letter, one number, and one special character.',
                    },
                  ]}
                >
                  <Input.Password
                    placeholder='Enter new password'
                    size='large'
                  />
                </Form.Item>

                {/* Confirm Password */}
                <Form.Item
                  label='Confirm Password'
                  name='confirmPassword'
                  dependencies={['password']} // Watch the 'password' field
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }

                        return Promise.reject(
                          new Error('Passwords do not match!'),
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    placeholder='Confirm your password'
                    size='large'
                  />
                </Form.Item>

                {/* Buttons */}
                <div className='flex justify-between'>
                  <Form.Item>
                    <Button
                      type='primary'
                      htmlType='submit'
                      loading={isLoading}
                      size='large'
                    >
                      Set Password
                    </Button>
                    <Button
                      size='large'
                      onClick={() => navigate(ROUTES.LOGIN)}
                      className='text-blue-950 hover:text-blue-950 ml-5'
                    >
                      Back to Login
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </Col>
          </StyledRow>
        </StyledCard>
      </Col>
    </StyledBackground>
  );
};
